import { PaginationState, RowSelectionState } from "@tanstack/react-table"

import { useCustomReactTable } from "~/components/hooks/useCustomReactTable"
import { ProductCustomFieldsItemResponseDto } from "~/gen/api"
import { useProductsCustomFieldsColumns } from "~/pages/Brand/Products/List/Components/ProductsTables/custom-fields/custom-fields.columns"

export type Props = {
  pagination: PaginationState
  rowSelection: RowSelectionState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  setRowSelection: React.Dispatch<React.SetStateAction<RowSelectionState>>
  pageCount: number
  customFieldKeys: string[]
  products: ProductCustomFieldsItemResponseDto[]
}

export const useProductsCustomFieldsTable = ({
  pagination,
  rowSelection,
  setPagination,
  setRowSelection,
  pageCount,
  customFieldKeys,
  products,
}: Props) => {
  const columns = useProductsCustomFieldsColumns(customFieldKeys)

  const table = useCustomReactTable({
    data: products,
    columns,
    state: {
      pagination,
      columnPinning: {
        left: ["name", "brandReference"],
      },
      rowSelection,
    },
    pageCount,
    manualPagination: true,
    enableRowSelection: true,
    onPaginationChange: setPagination,
    onRowSelectionChange: setRowSelection,
  })

  return table
}
